import React from 'react';
import GeneralWidgetSm from './widgets/GeneralWidgetSm';
import StageWidgetSm from './widgets/StageWidgetSm';
import WeatherWidgetSm from './widgets/WeatherWidgetSm';
import TrendWidgetSm from './widgets/TrendWidgetSm';
import ForecastPeakWidgetSm from './widgets/ForecastPeakWidgetSm';
import FlowWidgetSm from './widgets/FlowWidgetSm';
import HistoricalPeakWidgetSm from './widgets/HistoricalPeakWidgetSm';
import useMapStore from 'src/stores/mapStore';
import useGaugeDetails from 'src/lib/hooks/useGaugeDetails';
import useHistoricPeakEvents from 'src/lib/hooks/useHistoricPeakEvents';
import { hasForecastData } from 'src/lib/forecastUtils';
import useUserGroup from 'src/lib/hooks/useUserGroup';


const CurrentTabContentSm = () => {
  const activeGauge = useMapStore(state => state.activeGauge);
  const { data: gauge } = useGaugeDetails(activeGauge?.attributes?.siteId);
  const { events, isLoading: isHistoryLoading } = useHistoricPeakEvents(activeGauge?.attributes.siteId);
  const { isAdmin, isAdvanced } = useUserGroup();


  const { inService, currentFlow } = gauge;
  const hasWeatherData = () => {
    return gauge?.rainCondition === 1;
  }

  return (
    <div className="d-flex flex-column dark-gray-background">
      <GeneralWidgetSm />
      {inService && (
        <>
          <StageWidgetSm />
          {hasWeatherData() && <WeatherWidgetSm />}
          <TrendWidgetSm />
          {hasForecastData(gauge, isAdmin, isAdvanced) && <ForecastPeakWidgetSm />}
          {currentFlow !== null && <FlowWidgetSm />}
          {!isHistoryLoading && events.length > 0 &&
            <HistoricalPeakWidgetSm />
          }
        </>
      )}

    </div>
  );
};


export default CurrentTabContentSm;